export const addFilterToLink = (
  link: string | null,
  filter: string
): string => {
  if (!link) return '';
  const url = new URL(link);
  url.searchParams.set('filter', filter);
  return url.toString();
};

export type HomeView =
  | 'title_and_abstract'
  | 'full_text_review'
  | 'extraction'
  | 'review_setup_basic_wizard'
  | 'import_summary';

type StageCounts = { screen: number; select: number; included: number };

export const firstOpenView = ({
  screen,
  select,
  included,
}: StageCounts): HomeView => {
  if (screen > 0) {
    return 'title_and_abstract';
  }

  if (select > 0) {
    return 'full_text_review';
  }

  if (included > 0) {
    return 'extraction';
  }

  const isReviewSetupComplete = false; // TODO: Replace with real check

  if (!isReviewSetupComplete) {
    return 'review_setup_basic_wizard';
  }

  return 'import_summary';
};
